<template>
  <div class="c-tabs-panel">
    <i-table :columns="columns" :queryParams="queryParams" :url="url" ref="table"></i-table>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'

  import ITable from '@/views/workbench/components/Itable.vue'
  export default {
    name: 'Bpbj',
    components: {
      ITable
    },
    props: {
      deviceData: {
        type: Object,
        default: () => { }
      }
    },
    // 定义属性
    data () {
      return {
        defaultLoadData: false,
        queryParams: {

        },
        url: '/spareparts/devBpbjStandardInfo/queryBpbjStandardByDevTypeIds',
        columns: [
          {
            title: '备件名称',
            align: 'center',
            dataIndex: 'bjName'
          },

          {
            title: '备件型号',
            align: 'center',
            dataIndex: 'bjModel'
          },
          {
            title: '备件型号规格',
            align: 'center',
            dataIndex: 'bjModelSpec'
          },
          {
            title: '备件生产厂家',
            align: 'center',
            dataIndex: 'manuId_dictText'
          },
          {
            title: '标准寿命(月)',
            align: 'center',
            dataIndex: 'ageMonth'
          },
          // {
          //   title: '时间',
          //   align: 'center',
          //   dataIndex: 'unit'
          // }
        ],
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters([''])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {

      this.queryParams = {
        bpbjType: '2',
        devModelId: this.deviceData.devTypeId
      }
      if (this.deviceData.devTypeId) {
        this.$nextTick(() => { this.queryData() })
      }
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {
      queryData () {
        this.$refs.table.loadData()
      }
    }
  }
</script>

<style lang='scss' scoped>


</style>